export default "__VITE_ASSET__C$gyFiPY__"